var map = {
	"./affect/Goals.vue": [
		"7ef1",
		"chunk-2d0e290f"
	],
	"./cognitive-function/Goals.vue": [
		"8d88",
		"chunk-2d0e9422"
	],
	"./energy-fatigue/Goals.vue": [
		"dfdb",
		"chunk-2d22a176"
	],
	"./pain/Goals.vue": [
		"2acb",
		"chunk-2d0bd404"
	],
	"./sleep/Goals.vue": [
		"306e",
		"chunk-52abca50"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5577";
module.exports = webpackAsyncContext;